import React from 'react';
import { CnTag } from '../../../../components/cn-tag';
import './index.scss';
export var EntryPointsTags = function (props) {
    var onItemClick = props.onItemClick, dataSource = props.dataSource;
    if (!(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length))
        return null;
    return (React.createElement("div", { className: "cn-ui-m-entry-points-tags" }, dataSource.map(function (tag) { return (React.createElement(CnTag, { key: tag.value, onClick: function (event) { return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(tag, event); } }, tag.label)); })));
};
